// Helper function to wait for product elements to be rendered

import { nvProductHelpers } from "../helpers/product-helpers";
import { CartService } from "../services/ApiAcccess.service";
import { nvstore } from "../state/store";
import { actionTypes } from "../state/actions/cartActions";
import nvCartTranslations from "../translations/nvCartTranslations";
import { getLocaleConfig } from "../utils/locale.utils";
import { StorageUtils } from "../utils/storage.utils";
import { DOMUtils } from "../utils/dom.utils";
import { ProductContext } from "./product.context";

export interface MarketplaceConsumerPdpRoute {
    locale: string;
    marketplaceCategory: 'consumer';
    consumerCategory: string;
    pdpSlug: string;
}

/**
 * Parses marketplace consumer PDP URLs with the shape:
 * /{locale}/consumer/{consumerCategory}/{pdpSlug}/
 */
export const parseMarketplaceConsumerPdpRoute = function (
    input?: string | null
): MarketplaceConsumerPdpRoute | null {
    const rawInput = input ?? (typeof window !== 'undefined' ? window.location.href : '');
    if (!rawInput) {
        return null;
    }

    let pathname = '';
    try {
        if (rawInput.startsWith('http://') || rawInput.startsWith('https://')) {
            pathname = new URL(rawInput).pathname;
        } else {
            pathname = rawInput;
        }
    } catch (_error) {
        return null;
    }

    const match = pathname.match(/^\/([a-z]{2}-[a-z]{2})\/(consumer)\/([^/]+)\/([^/]+)\/?$/i);
    if (!match) {
        return null;
    }

    return {
        locale: match[1].toLowerCase(),
        marketplaceCategory: 'consumer',
        consumerCategory: match[3],
        pdpSlug: match[4]
    };
};

export const isMarketplaceConsumerPdpPage = function (input?: string | null): boolean {
    return parseMarketplaceConsumerPdpRoute(input) !== null;
};

// Retries up to 20 times with 300ms interval (total 6 seconds max wait time)
export const waitForProductElements = function (maxAttempts = 20, interval = 300): Promise<NodeListOf<Element>> {
    return new Promise((resolve, reject) => {
        let attempts = 0;

        const checkForElements = () => {
            const elements = DOMUtils.querySelectorAll('.js-product-item');

            if (elements && elements.length > 0) {
                resolve(elements);
            } else if (attempts >= maxAttempts) {
                reject(new Error('Product elements not found after maximum attempts'));
            } else {
                attempts++;
                setTimeout(checkForElements, interval);
            }
        };

        checkForElements();
    });
};
export const bcPidConfig = function (bcDivRef: HTMLElement, options: any, pidObj: any, cartProductsList: any[]) {
    var marketplaceId = bcDivRef.dataset.marketplaceId;
    // comparing the id with inventory api response
    const { apiCurrency, DRlocale, PromoLocale } = getLocaleConfig(options.locale);
    var product = nvProductHelpers.findProductById(cartProductsList, marketplaceId);
    var productFullPrice: any = null;
    var product_price: any = null;
    if (product != null) {
        const pricing = (product as any).pricing;
        if (pricing && pricing.listPriceWithQuantity != null && pricing.salePriceWithQuantity != null) {
            productFullPrice = pricing.listPriceWithQuantity;
            product_price = pricing.salePriceWithQuantity;
            // if (product.pricing.salePriceWithQuantity != product.listPriceWithQuantity) {
            //     $(bcDivRef).find('.js-product-price').parent().prepend('<div class="list-price-striked hide">' + cartHelpers.localisePriceDisplay(options.apiCurrency, productFullPrice) + '</div>');
            // }
            const priceElement = (bcDivRef as HTMLElement).querySelector('.js-product-price');
            if (priceElement) {
                priceElement.textContent = product_price;
            }
        } else {
            productFullPrice = getProductPriceById(marketplaceId, 'bc');
            product_price = getProductPriceById(marketplaceId, 'bc');
            const intLocale = PromoLocale.replace('_', '-');
            const intProductFullPrice = parseFloat(getProductPriceById(marketplaceId, 'bc'));
            const localisePrice = Intl.NumberFormat(intLocale, { style: "currency", currency: apiCurrency }).format(
                parseFloat(product_price),
            );
            const priceElement = (bcDivRef as HTMLElement).querySelector('.js-product-price');
            if (priceElement) {
                priceElement.textContent = localisePrice;
            }
        }
        var productIsInStock = (product.inventoryStatus as any).productIsInStock;

        // below values will be from attributes
        var additionalCartMessage = "";


        // product_status="PRODUCT_INVENTORY_OUT_OF_STOCK";
        if (productIsInStock) {
            const ctaButton = bcDivRef.querySelector('.cta-button') as HTMLElement;
            if (ctaButton) {
                //ctaButton.innerHTML = nvCartTranslations.translations.buyNow[options.locale];
                ctaButton.classList.remove("stock-grey-out", 'show-out-of-stock');
                ctaButton.classList.add('js-add-button');
                if (ctaButton.parentElement) {
                    ctaButton.parentElement.classList.remove('link-btn-disabled', "bc-spinner-bg");
                }
                ctaButton.style.visibility = 'visible';

                if (isMarketplaceConsumerPdpPage) {
                    const retailersList = document.querySelector('#form-action-retailer') as HTMLElement;
                    if (retailersList) {
                        retailersList.style.display = 'none';
                        retailersList.innerHTML = '';
                    }
                }
            }

            if (additionalCartMessage != null) {
                const additionalMsgEl = bcDivRef.querySelector('.additional-message') as HTMLElement;
                if (additionalMsgEl) {
                    additionalMsgEl.style.display = 'block';
                    additionalMsgEl.innerHTML = additionalCartMessage;
                }
            }

            const productMsgEl = bcDivRef.querySelector(".product__message") as HTMLElement;
            if (productMsgEl) productMsgEl.style.display = 'block';
            bcDivRef.style.visibility = 'visible';
            bcDivRef.style.color = '2464';
            // ✅ Converted from jQuery to ES6
            // Clone only this specific product element to remove existing handlers
            const productItem = bcDivRef.closest('.js-product-item') || bcDivRef;
            const newProductItem = productItem.cloneNode(true);
            if (productItem.parentNode) {
                productItem.parentNode.replaceChild(newProductItem, productItem);

                // Add event delegation for .js-add-button clicks
                newProductItem.addEventListener('click', function (event) {
                    const target = event.target as HTMLElement;
                    const addButton = target.closest('.js-add-button') as HTMLButtonElement;

                    if (addButton) {
                        // Prevent multiple clicks while processing
                        if (addButton.disabled) {
                            return false;
                        }

                        event.stopImmediatePropagation();
                        let quantity;
                        let productIDs = [];
                        let productId = null;
                        const componentRoot = event.currentTarget as HTMLElement;
                        productId = componentRoot.getAttribute('data-marketPlace-id');
                        let cartData = [];

                        // Disable button to prevent multiple clicks
                        addButton.disabled = true;
                        const originalButtonText = addButton.innerHTML;
                        addButton.innerHTML = 'Adding...';

                        if (productId) {
                            quantity = 1;
                            productId = componentRoot.getAttribute('data-marketPlace-id');
                            const cartItems = { "productId": productId, "quantity": 1 };
                            cartData.push(cartItems);
                            const directPids = sessionStorage.getItem('directPids');
                            const nvDirectCheckout = sessionStorage.getItem('nvDirectCheckout');

                            const handleComplete = () => {
                                // Re-enable button after action completes
                                addButton.disabled = false;
                                addButton.innerHTML = originalButtonText;
                            };

                            const handleError = () => {
                                // Re-enable button on error
                                addButton.disabled = false;
                                addButton.innerHTML = originalButtonText;
                            };

                            if ((options.isMultiline || options.mountId === "nv-cart-item")) {
                                // Dispatch action and re-enable button after a short delay
                                // This allows Redux to process the action
                                nvstore.dispatch({
                                    type: actionTypes.ADD_ITEM_TO_CART,
                                    id: productId,
                                    quantity: quantity,
                                    category: 'nvidia'
                                });
                                // Re-enable button after Redux processes the action
                                setTimeout(() => {
                                    handleComplete();
                                }, 500);
                            } else {
                                CartService.checkout({ items: cartData, purge: false, category: 'nvidia', isDigital: product.productType === 'DIGITAL' })
                                    .then(handleComplete)
                                    .catch(handleError);
                            }
                            sessionStorage.setItem('category', 'nvidia');
                        } else {
                            // Re-enable button if no productId
                            addButton.disabled = false;
                            addButton.innerHTML = originalButtonText;
                        }

                        return false;
                    }
                });
            }
        }
    } // product == null end
    else {
        const ctaButton = bcDivRef.querySelector('.cta-button');
        if (ctaButton) {
            ctaButton.innerHTML = nvCartTranslations.translations.outOfStock[options.locale];
            ctaButton.classList.remove('js-add-button', 'stock-in');
            ctaButton.classList.add('stock-grey-out');
            if (ctaButton.parentElement) {
                ctaButton.parentElement.classList.remove('link-btn', 'brand-green', "dr-spinner-bg-grid", "dr-spinner-bg");
                ctaButton.parentElement.classList.add('link-btn-disabled');
            }
        }
        const productMsgEl = bcDivRef.querySelector(".product__message") as HTMLElement;
        if (productMsgEl) productMsgEl.style.display = 'none';
        const freeShippingEl = bcDivRef.querySelector('.free-shipping') as HTMLElement;
        if (freeShippingEl) freeShippingEl.style.display = 'none';
        const shipDateEl = bcDivRef.querySelector('.ship-date') as HTMLElement;
        if (shipDateEl) shipDateEl.style.display = 'none';
        bcDivRef.style.visibility = 'visible';
        bcDivRef.style.color = '2464';
    }
    DOMUtils.querySelectorAll('.dr-spinner-bg').forEach((el: HTMLElement) => (el as HTMLElement).style.backgroundImage = "none");
    DOMUtils.querySelectorAll('.dr-spinner-bg-grid').forEach((el: HTMLElement) => (el as HTMLElement).style.backgroundImage = "none");
}


// Function to get the data-product-title value based on a specific data-digital-river-id value
export const getProductTitleById = function (idValue, category) {
    // Use querySelector to select the element with the specified data-digital-river-id
    let element;
    if (category === 'bc') {
        element = DOMUtils.querySelector(`[data-marketPlace-id="${idValue}"]`);
    } else {
        element = DOMUtils.querySelector(`[data-digital-river-id="${idValue}"]`);
    }
    // Check if the element exists, and if so, get the data-product-title attribute value
    if (element) {
        return element.getAttribute("data-product-title");
    } else {
        return null;  // Return null if no element is found
    }
}

// Function to get the data-product-price value based on a specific data-digital-river-id value
export const getProductPriceById = function (idValue, category) {
    let element;
    if (category === 'bc') {
        element = DOMUtils.querySelector(`[data-marketPlace-id="${idValue}"]`);
    } else {
        element = DOMUtils.querySelector(`[data-digital-river-id="${idValue}"]`);
    }
    return element ? element.getAttribute("data-product-price") : null;
}

// ✅ Global flag to prevent concurrent scanProducts executions
let isScanningProducts = false;
let scanProductsPromise: Promise<void> | null = null;

export const scanProducts = function (options, isHeadless: boolean) {
    const pdpRoute = parseMarketplaceConsumerPdpRoute();
    const isPdpPage = pdpRoute !== null;

    // ✅ GUARD: If already scanning, return the existing promise
    if (isScanningProducts && scanProductsPromise) {
        return scanProductsPromise;
    }

    // ✅ GUARD: Check if products are already fully scanned AND DOM elements are configured
    const existingProductsList = ProductContext.getCartProductsList();
    if (existingProductsList && existingProductsList.length > 0) {
        // Quick check: collect product IDs from DOM
        const productElements = DOMUtils.querySelectorAll('.js-product-item');
        const collectedIds: string[] = [];

        productElements.forEach((productElement) => {
            if (productElement instanceof HTMLElement) {
                const mrktId = productElement.getAttribute('data-marketPlace-id');
                if (mrktId) {
                    collectedIds.push(mrktId);
                }
            }
        });

        // Check if all product IDs are already in the existing list
        const allProductsExist = collectedIds.length > 0 && collectedIds.every(pid =>
            existingProductsList.some(existing =>
                String(existing.id) === String(pid) ||
                String(existing.pid) === String(pid)
            )
        );

        // Only skip if products exist AND all DOM elements are already configured
        // Check if elements have the 'js-add-button' class (indicating bcPidConfig has run)
        if (allProductsExist && collectedIds.length > 0) {
            const allElementsConfigured = Array.from(productElements).every(el => {
                const addButton = el.querySelector('.js-add-button');
                return addButton !== null;
            });
            
            if (allElementsConfigured) {
                return Promise.resolve();
            }
        }
    }

    // Set scanning flag
    isScanningProducts = true;

    scanProductsPromise = new Promise<void>(async function (resolve, reject) {
        var cartProductsList: any[] = [];
        var bc_resp_pids = [];
        var cartObj;
        var productObjWithVariations = [];
        var productElements = DOMUtils.querySelectorAll('.js-product-item');
        var product_Ids = [];
        let cartData = StorageUtils.getCookie('nvHeadless');



        // Async function to collect product IDs and cache element references
        async function collectProductIds() {
            console.log('productElements==>', productElements);
            productElements.forEach((productElement) => {
                console.log('productElement', productElement);
                if (productElement instanceof HTMLElement) {
                    const category = productElement.getAttribute('data-product-category');
                    const mrktId = productElement.getAttribute('data-marketPlace-id');
                    const skuId = productElement.getAttribute('data-sku-id');
console.log('mrktId==>', mrktId, skuId, category);
                    if (mrktId) {
                        product_Ids.push({ id: mrktId, skuId: skuId, category: category });
                    }
                }
            });
            console.log('product_Ids==>',cartData, cartObj);
            if (cartData && cartData.cart && cartData.cart.length > 0) {
                cartObj = cartData.cart;
            }
            if (cartObj && cartObj.length > 0) {
                // Extract product IDs from decompressed cart items
                // cartData.cart is already decompressed by getCookie -> CartKeyService.decompress()
                productObjWithVariations = cartObj.map(function (item) {
                    // Cart items already have 'id' property after decompression
                    return item.id || null;
                }).filter(function (val) { return val != null });
            }
            console.log('product_Ids==>', product_Ids, );
            return { product_Ids, productObjWithVariations };
        }

        (async function () {
            // Always try to collect product IDs (from DOM elements or cart cookie)
            const { product_Ids, productObjWithVariations } = await collectProductIds();

            if (productElements && productElements.length || productObjWithVariations && productObjWithVariations.length > 0) {
                // Use Set to avoid duplicates
                var tempObjSet = new Set([productObjWithVariations]);
                var tempObj = Array.from(tempObjSet);

                if (product_Ids && product_Ids.length > 0 || productObjWithVariations && productObjWithVariations.length > 0) {
                    // ✅ Converted from jQuery: $.each() → forEach(), $.inArray() → indexOf()
                    product_Ids.forEach((ele, i) => {
                        if (cartProductsList.indexOf(ele) === -1) {
                            cartProductsList.push(ele);
                        }
                    });
                    productObjWithVariations.forEach((ele, i) => {
                        if (cartProductsList.indexOf(ele) === -1) {
                            cartProductsList.push(ele);
                        }
                    });
                    // Update global context
                    ProductContext.setCartProductsList(cartProductsList);
                }
                // Collect product IDs from both DOM elements and cart cookie
                const allProductIds = [
                    ...(product_Ids && product_Ids.length ? product_Ids.map(p => p.id) : []),
                    ...(productObjWithVariations && productObjWithVariations.length ? productObjWithVariations : [])
                ];

                var productObj = {
                    ...((allProductIds && allProductIds.length) && { "partner_pids": allProductIds }),
                    "locale": getLocaleConfig(options.locale)?.PromoLocale,
                };
                if ((productObj['partner_pids'] && productObj['partner_pids'].length)) {
                    if ((Array.isArray(cartProductsList) && cartProductsList.length)) {
                        CartService.getProducts(productObj).then(pdpResponse => {
                            console.log('📦 API Response from getProducts:', {
                                requestedIds: productObj['partner_pids'],
                                returnedCount: pdpResponse?.length || 0,
                                returnedIds: pdpResponse?.map(p => p.pid) || []
                            });
                            
                            var partnerResponse = (pdpResponse && pdpResponse.length) ? pdpResponse.filter(item => item.partner) : [];
                            if (partnerResponse && partnerResponse.length) {
                                cartProductsList = partnerResponse;
                                // Don't update ProductContext here - wait until after transformation
                            }
                            // Always call getFEInventory for all partner_pids
                            (async () => {
                                // Track products from cart that need updating (for batch SET_CART)
                                const cartProductIdsToUpdate = new Set(productObjWithVariations);
                                const updatedCartProducts: any[] = [];
                                
                                const partnerShipPromises = await Promise.all(
                                    productObj['partner_pids'].map(async (partnerId) => {
                                        // Match `id` and get the corresponding product object
                                        const bcpidObj = cartProductsList.find(
                                            (obj) => obj.pid === partnerId
                                        );

                                        // Try to find from DOM elements first, fallback to creating minimal object
                                        let pidObj = product_Ids && product_Ids.length
                                            ? product_Ids.find((a) => a.id === partnerId)
                                            : null;

                                        // If no pidObj from DOM, check if it's from cart cookie
                                        if (!pidObj && productObjWithVariations.includes(partnerId)) {
                                            // Create minimal pidObj for products from cart cookie
                                            pidObj = {
                                                id: partnerId,
                                                skuId: partnerId,
                                                category: bcpidObj?.partner ? 'partner' : 'nvidia'
                                            };
                                        }

                                        if (!pidObj || !bcpidObj) {
                                            console.warn('⚠️ Skipping product configuration:', {
                                                partnerId,
                                                hasPidObj: !!pidObj,
                                                hasBcpidObj: !!bcpidObj,
                                                reason: !pidObj ? 'Missing DOM element data' : 'Product not returned by API'
                                            });
                                            return;
                                        }

                                        try {
                                            if (bcpidObj.productType !== 'DIGITAL') {
                                                const inventoryResponse = await CartService.getFEInventory({
                                                    products: pidObj?.skuId || "",
                                                });
                                            }
                                            const listMap = { is_active: bcpidObj.productType === 'DIGITAL' };

                                            // ✅ Use cached data instead of DOM queries, fallback to API response name
                                            const productTitle = getProductTitleById(partnerId, "bc") || bcpidObj.name;

                                            const productData = {
                                                id: partnerId,
                                                sku: pidObj.skuId,
                                                upc: pidObj.skuId,
                                                currency: (bcpidObj as any)?.currency || "USD",
                                                name: productTitle || (bcpidObj as any)?.name || "",
                                                displayName: productTitle|| (bcpidObj as any)?.name || "",
                                                isQuantity: listMap.is_active,
                                                productType: String((bcpidObj as any)?.productType || "DIGITAL").toUpperCase(),
                                                locale: options.locale,
                                                category: bcpidObj?.partner ? 'partner' : 'nvidia',
                                                listPriceWithQuantity: bcpidObj.formattedListPrice || null,
                                                salePriceWithQuantity: bcpidObj.formattedListPrice || null,
                                                unitPrice: bcpidObj.price || null,

                                                pricing: {
                                                    listPriceWithQuantity: bcpidObj?.formattedListPrice || null,
                                                    salePriceWithQuantity: bcpidObj?.formattedListPrice || null,
                                                    unitPrice: bcpidObj.price || null
                                                },
                                                inventoryStatus: {
                                                    productIsAllowsBackorders: false,
                                                    productIsInStock: listMap.is_active,
                                                    status: listMap.is_active,
                                                    availableQuantity: listMap.is_active,
                                                },
                                                maximumQuantity: listMap.is_active ? bcpidObj.maximumQuantity : 1,
                                                minimumQuantity: listMap.is_active ? bcpidObj.minimumQuantity : 1,
                                            };

                                            // Check for existing product by comparing both pid and id (as strings)
                                            const existingIndex = cartProductsList.findIndex(item =>
                                                String(item.pid || item.id) === String(partnerId) ||
                                                String(item.id || item.pid) === String(partnerId)
                                            );
                                            if (existingIndex !== -1) {
                                                cartProductsList[existingIndex] = productData;
                                            } else {
                                                cartProductsList.push(productData);
                                            }

                                            bc_resp_pids.push(productData);

                                            // ✅ Only track products from cart for batch update
                                            if (cartProductIdsToUpdate.has(partnerId)) {
                                                updatedCartProducts.push({
                                                    partnerId,
                                                    productData
                                                });
                                            }

                                            // ✅ Convert NodeList to Array to use find method
                                            const element = Array.from(productElements).find(el => el.getAttribute('data-marketPlace-id') === partnerId.toString()) as HTMLElement;
                                            if (element && isHeadless !== undefined) {
                                                bcPidConfig(element, options, pidObj, cartProductsList);
                                                console.log('✅ bcPidConfig executed for product:', partnerId);
                                            } else {
                                                console.warn('⚠️ Could not run bcPidConfig:', {
                                                    partnerId,
                                                    hasElement: !!element,
                                                    isHeadless
                                                });
                                            }
                                        } catch (error) {
                                            // Silent error handling
                                        }
                                    })
                                );
                                if (partnerShipPromises) {
                                    // ✅ Converted from jQuery: $.when.apply($, promises) → Promise.all(promises)
                                    Promise.all(partnerShipPromises).then(function () {
                                        // Final update to global context
                                        ProductContext.setCartProductsList(cartProductsList);

                                        // ✅ Batch update Redux cart - dispatch SET_CART only once for all cart products
                                        if (updatedCartProducts.length > 0) {
                                            const currentState = nvstore.getState();
                                            if (currentState.cart && currentState.cart.length > 0) {
                                                const updatedCart = [...currentState.cart];
                                                let hasUpdates = false;
                                                
                                                // Update each cart item that has new product data
                                                updatedCartProducts.forEach(({ partnerId, productData }) => {
                                                    const cartItemIndex = updatedCart.findIndex((item: any) =>
                                                        String(item.id) === String(partnerId) ||
                                                        String(item.id) === String(productData.id)
                                                    );
                                                    
                                                    if (cartItemIndex !== -1) {
                                                        const existingCartItem = updatedCart[cartItemIndex];
                                                        
                                                        // Calculate totalPrice based on quantity and unitPrice
                                                        const unitPriceNum = parseFloat(String(productData.unitPrice)) || parseFloat(String(existingCartItem.listPrice)) || 0;
                                                        const calculatedTotalPrice = (existingCartItem.quantity * unitPriceNum).toFixed(2);
                                                        
                                                        // Merge new product data with existing cart item, preserving cart-specific fields
                                                        updatedCart[cartItemIndex] = {
                                                            ...existingCartItem,
                                                            ...productData,
                                                            id: existingCartItem.id,
                                                            quantity: existingCartItem.quantity,
                                                            category: existingCartItem.category,
                                                            activeTab: existingCartItem.activeTab || existingCartItem.category,
                                                            expires: existingCartItem.expires,
                                                            locale: existingCartItem.locale,
                                                            // Ensure required CartProduct fields are present
                                                            name: productData.displayName || productData.name || existingCartItem.name,
                                                            listPrice: unitPriceNum,
                                                            unitPrice: unitPriceNum,
                                                            totalPrice: calculatedTotalPrice,
                                                            pricing: {
                                                                listPriceWithQuantity: productData.pricing?.listPriceWithQuantity || unitPriceNum,
                                                                salePriceWithQuantity: productData.pricing?.salePriceWithQuantity || unitPriceNum,
                                                                unitPrice: unitPriceNum
                                                            },
                                                            productIsInStock: productData.inventoryStatus?.productIsInStock ?? existingCartItem.productIsInStock ?? true,
                                                            productIsAllowsBackorders: productData.inventoryStatus?.productIsAllowsBackorders ?? existingCartItem.productIsAllowsBackorders ?? false,
                                                            minimumQuantity: productData.minimumQuantity || existingCartItem.minimumQuantity || 1,
                                                            limitPerCustomer: productData.maximumQuantity || existingCartItem.limitPerCustomer || null,
                                                            availableQuantity: existingCartItem.availableQuantity ?? null
                                                        };
                                                        hasUpdates = true;
                                                    }
                                                });
                                                
                                                // Dispatch SET_CART once with all updates
                                                if (hasUpdates) {
                                                    nvstore.dispatch({
                                                        type: actionTypes.SET_CART,
                                                        cart: updatedCart,
                                                        lastAction: null
                                                    });
                                                }
                                            }
                                        }

                                        // ✅ Reset scanning flag
                                        isScanningProducts = false;
                                        scanProductsPromise = null;

                                        resolve(undefined);
                                    }).catch((error) => {
                                        // ✅ Reset scanning flag on error
                                        isScanningProducts = false;
                                        scanProductsPromise = null;
                                        reject(error);
                                    });
                                }
                                if (!JSON.parse(StorageUtils.getSessionItem('checkoutClicked') || 'false')) {
                                    DOMUtils.removeClass(document.body, "loading");
                                }
                            })();
                        }).catch(error => {
                            DOMUtils.querySelectorAll('.js-product-item').forEach((el: any) => {
                                const ctaButton = el.querySelector('.cta-button');
                                if (ctaButton) {
                                    ctaButton.innerHTML = nvCartTranslations.translations.outOfStock[options.locale];
                                    ctaButton.classList.remove('js-add-button', 'stock-in');
                                    ctaButton.classList.add('stock-grey-out');
                                    // Apply inline styles for stock-grey-out
                                    ctaButton.style.backgroundColor = '#dadada';
                                    ctaButton.style.color = '#666';
                                    if (ctaButton.parentElement) {
                                        ctaButton.parentElement.classList.remove('link-btn', 'brand-green');
                                        ctaButton.parentElement.classList.add('link-btn-disabled');
                                    }
                                }
                                el.style.visibility = 'visible';
                                el.style.color = 'failed';
                            });
                            DOMUtils.querySelectorAll('.dr-spinner-bg-grid').forEach((el: any) => el.style.backgroundImage = "none");
                            DOMUtils.querySelectorAll('.dr-spinner-bg').forEach((el: any) => el.style.backgroundImage = "none");

                            // ✅ Reset scanning flag on error
                            isScanningProducts = false;
                            scanProductsPromise = null;

                            reject();
                        });
                    } else {
                        // ✅ Reset scanning flag on error
                        isScanningProducts = false;
                        scanProductsPromise = null;
                        reject('No products found');  // Reject the promise if no products are found
                    }
                } else {
                    // ✅ Reset scanning flag on error
                    isScanningProducts = false;
                    scanProductsPromise = null;
                    reject('No products available');  // Reject when no products available
                }
            } else {
                // ✅ Reset scanning flag on error
                isScanningProducts = false;
                scanProductsPromise = null;
                reject(isPdpPage ? 'No product elements found on PDP page' : 'No product elements found');  // Reject if no product elements are found
            }
        })();
    });

    return scanProductsPromise;
}

export const processCart = function (cartItems, category, callAddLineItems = false) {
    var digiproduct = cartItems.filter(function (product) {
        return product.productType == 'DOWNLOAD';
    });
    var hwproduct = cartItems.filter(function (product) {
        return product.productType == 'PHYSICAL';
    });
    var hwgiftcard = cartItems.filter(function (product) {
        return product.productType == 'PHYSICALGIFTCARD';
    });
    var hwandphysicalgiftcard = cartItems.filter(function (product) {
        return product.productType != 'DOWNLOAD';
    });
    var partnerCart = cartItems.filter((item) => item.category === 'partner');

    var updatedCart = cartItems;

    if (cartItems.length > 1) {
        if (digiproduct.length > 0 && hwandphysicalgiftcard.length > 0) {
            if (digiproduct.length > 0 && hwproduct.length > 0 && hwgiftcard.length > 0) {
                updatedCart = hwandphysicalgiftcard;
            } else if (digiproduct.length > 0 && hwproduct.length > 0) {
                updatedCart = hwproduct;
            } else if (digiproduct.length > 0 && hwgiftcard.length > 0) {
                if (cartItems[0].productType == 'DOWNLOAD') {
                    updatedCart = digiproduct;
                } else {
                    updatedCart = hwgiftcard;
                }
            }
        } else {
            updatedCart = cartItems;
        }
    } else {
        updatedCart = cartItems;
    }

    // Combine updatedCart and partnerCart with the entire state.cart to maintain all objects
    if (partnerCart && partnerCart.length) {
        // Iterate over partnerCart
        for (var i = 0; i < partnerCart.length; i++) {
            var partnerItem = partnerCart[i];
            var itemExists = false;

            // Iterate over updatedCart to check for matching ids
            for (var j = 0; j < updatedCart.length; j++) {
                if (updatedCart[j].id === partnerItem.id) {
                    // If a matching id is found, update the existing object
                    updatedCart[j] = partnerItem;
                    itemExists = true;
                    break;
                }
            }

            // If no matching id is found, add the new object to updatedCart
            if (!itemExists) {
                updatedCart.push(partnerItem);
            }
        }
    }

    nvstore.dispatch({
        type: actionTypes.SET_CART,
        cart: updatedCart,
        lastAction: null
    });

    // Pass only the filtered cart items that match the category
    let checkoutCart = updatedCart.filter(item => item.category === category);

    if (callAddLineItems) {
        CartService.addLineItems({
            products: checkoutCart,
            challenge: JSON.parse(StorageUtils.getSessionItem('checkoutClicked') || 'false'),
            category: category,
            isDigital: digiproduct.length === cartItems.length
        });
    } else {
        CartService.checkout({ items: checkoutCart, purge: false, category: category, isDigital: digiproduct.length === cartItems.length });
    }
};
